//#region REACT
/* eslint-disable react/jsx-pascal-case */
import { useEffect } from "react";
import React, { useState } from "react";
import { MapContainer, TileLayer, Marker, useMap } from "react-leaflet";
import axios from "axios";
//#endregion

//#region STYLES
import "leaflet/dist/leaflet.css";
import styled from "styled-components";
//#endregion

//#region COMPONENTS
import { NanoFlex } from "../../Elements/NanoFlex";
import { markerRed, markerOrange, markerYellow, markerHouseBlue } from "./Icon";
import MapPopup from "./MapPopup";
import MapHeader from "../MapHeader/MapHeader";
//#endregion

//#region UTILS
import { endpoints } from "../../../core/constants";
import { Severity } from "../../../core/constants";
import { Metrics } from "../../../core/constants";
import { formatDate } from "../../../core/utils";
//#endregion

//#region STYLED COMPONENTS
const StyledMapControl = styled(NanoFlex)``;
//#endregion

export default function MapControl({
  indicatorSelected,
  severitySelected,
  allHouses,
}) {
  //#region VARS
  var dateLessSevenDays = new Date();
  dateLessSevenDays.setDate(dateLessSevenDays.getDate() - 7);

  const headers = {
    cache: "default",
    mode: "cors",
    credentials: "include",
    "content-type": "application/json",
  };
  //#endregion

  //#region STATE

  const [markers, setMarkers] = useState([]);
  const [houses, setHouses] = useState([]);
  const [incidents, setIncidents] = useState([]);
  const [incidentsTable, setIncidentsTable] = useState([]);
  const [loadingIncidentsTable, setLoadingIncidentsTable] = useState(true);
  const [dateFilter, setDateFilter] = useState(dateLessSevenDays);
  const [map, setMap] = useState(null);

  //#endregion

  //#region FUNCTIONS

  const getHouses = () => {
    axios
      .get(endpoints.monitored_houses, {
        headers: headers,
        withCredentials: true,
      })
      .then((response) => {
        setHouses(
          response.data.result.filter(
            (f) => f.latitude !== "" && f.longitude !== ""
          )
        );
      });
  };

  const getIncidents = () => {
    axios
      .get(endpoints.incidents + "?active=1", {
        headers: headers,
        withCredentials: true,
      })
      .then((response) => {
        setIncidents(response.data.result);
      });
  };

  //#endregion

  //#region USE EFFECTS
  //LOAD
  useEffect(() => {
    getHouses();
    getIncidents();
    console.log("houses: ", houses)
  }, []);

  //DATE INSIDE MODAL CHANGES
  useEffect(() => {
    setLoadingIncidentsTable(true);

    axios
      .get(endpoints.incidents + "?open_date=" + formatDate(dateFilter), {
        headers: headers,
        withCredentials: true,
      })
      .then((response) => {
        var result = response.data.result.filter((f) =>
          sessionStorage
            .getItem("monitored_houses")
            ?.includes(f.affected_user_id)
        );

        setIncidentsTable(result);
        setLoadingIncidentsTable(false);
      });
  }, [dateFilter]);

  //FILTERS ON MAP PAGE CHANGE
  useEffect(() => {
    const incidentsResourceNames = (m) => {
      return incidents
        .filter(
          (f) =>
            m.resource_contact ===
            f.affected_user_id
          //.includes(f.affected_user.toLowerCase())
        )
        .map(({ category, priority }) => ({ category, priority }))[0];
    };

    var filteredMarkers = houses.map((m) => ({
      ...m,
      ...incidentsResourceNames(m),
    }));
    var housesFilteredMarkers = filteredMarkers;

    // FILTER DATA FOR SWITCH CASE
    // if (allHouses) {
    //   housesFilteredMarkers = housesFilteredMarkers.filter(
    //     (f) => f.priority === undefined
    //   );
    // }
    // FILTER DATA FOR SEVERITY
    if (severitySelected) {
      filteredMarkers = filteredMarkers.filter((f) => {
        const existentSeverities =
          Object.values(Severity)[severitySelected] ?? "";

        return existentSeverities
          .split(",")
          .some((v) => f.priority?.includes(v));
      });
    }
    // FILTER DATA FOR INDICATOR
    if (indicatorSelected) {
      filteredMarkers = filteredMarkers.filter((f) => {
        const existentIndicators =
          Object.values(Metrics)[indicatorSelected] ?? "";

        return existentIndicators
          .split(",")
          .some((v) => f.category?.includes(v));
      });
    }

    // UPDATE STATE WITH NEW DATA
    setMarkers(
      allHouses
        ? filteredMarkers.concat(housesFilteredMarkers)
        : filteredMarkers.filter((f) => f.priority)
    );
  }, [indicatorSelected, severitySelected, allHouses, houses, incidents]);

  //#endregion

  return (
    <StyledMapControl className="styledMapControl">
      <MapHeader></MapHeader>
      <MapContainer
        center={[38.74, -9.355]}
        zoom={11}
        scrollWheelZoom={true}
        attributionControl={false}
        zoomControl={false}
        whenCreated={setMap}
      >
        <TileLayer
          attribution='<a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png"
        />

        {markers.map((m, i) => {
          return (
            <Marker
              position={[m.latitude, m.longitude]}
              icon={
                m.priority === "3 - Medium" ||
                m.priority === "4 - Medium Low" ||
                m.priority === "5 - Low"
                  ? markerYellow
                  : m.priority === "2 - Medium High"
                  ? markerOrange
                  : m.priority === "1 - High"
                  ? markerRed
                  : markerHouseBlue
              }
              eventHandlers={{
                click: () => {
                  map.setView([m.latitude, m.longitude], 14);
                },
              }}
              key={`${i}_${m}`}
            >
              <MapPopup
                priority={m.priority}
                id={m.id}
                name={m.resource_contact_name}
                incidents={incidentsTable}
                loadingTable={loadingIncidentsTable}
                onDateFilterChange={(e) => setDateFilter(e)}
              ></MapPopup>
            </Marker>
          );
        })}
      </MapContainer>
    </StyledMapControl>
  );
}
